import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { CalanderIconSVG } from "../../assets/customIcons";
export var MuiDatePicker = function (props) {
    var id = props.id, name = props.name, label = props.label, value = props.value, onChange = props.onChange, fullWidth = props.fullWidth, disablePast = props.disablePast, disableFuture = props.disableFuture, error = props.error, placeholder = props.placeholder, minDate = props.minDate, disabled = props.disabled, maxDate = props.maxDate;
    var convertToDefEventPara = function (name, value) { return ({
        target: {
            name: name,
            value: value
        }
    }); };
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(DemoContainer, {
        sx: {
            "&.MuiStack-root": {
                overflow: "inherit",
                width: "100%"
            },
            borderColor: '#DEE4EB'
        },
        components: ["DatePicker", "DatePicker"]
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        value: value && dayjs(value, "DD/MM/YYYY"),
        format: "DD/MM/YYYY",
        disablePast: disablePast,
        disableFuture: disableFuture,
        slots: {
            openPickerIcon: CalanderIconSVG
            // previousIconButton:
        },
        minDate: minDate,
        disabled: disabled,
        sx: {
            "&.MuiFormControl-root": {
                minWidth: "100%"
            }
        },
        maxDate: maxDate ? maxDate : undefined,
        slotProps: {
            inputAdornment: {
                position: 'start'
            },
            textField: {
                id: id,
                size: "small",
                fullWidth: fullWidth,
                error: !!error,
                helperText: error,
                InputProps: {
                    placeholder: placeholder
                },
                sx: {
                    width: "100%",
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#DEE4EB'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#DEE4EB'
                        }
                    }
                }
            },
            openPickerButton: {
                id: name + '-picker-button'
            }
        },
        onChange: function (date) { return onChange(convertToDefEventPara(name, date)); }
    })));
};
